import Box from '@mui/material/Box';
import { useEffect, useMemo, useState } from 'react';
import { useSectionData } from '../../Sections/useSectionContext';
import { GridBlockType } from 'services/entities/BlockTypes';
import { useBlockContent } from '../../Sections/useBlockContent';
import AssetInsertTool from './AssetInsertTool';
import AssetSaveTool from './AssetSaveTool';
import './BlockSettingsToolsContainer.less';
import DeleteTool from './DeleteTool';
import LockTool from './LockTool';
import { ReassignSigneeTool } from './ReassignSigneeTool';

interface BlockSettingsToolsProps {
  blockId: string;
  isEditMode?: boolean;
  setIsEditMode?: (isEditMode: boolean) => void;
}

type BlockSettingsContainerPositionClassType = 'at-the-top' | 'at-the-bottom';

export function BlockSettingsToolsContainer({ blockId, isEditMode, setIsEditMode }: BlockSettingsToolsProps) {
  const blockContent = useBlockContent(blockId);
  const { blocksContent } = useSectionData();
  const blockType = blocksContent[blockId]?.type;

  const [positionClass, setPositionClass] = useState<BlockSettingsContainerPositionClassType>('at-the-top');

  const blockConfigY = useMemo(() => blockContent?.blockConfig?.y, [blockContent]);

  useEffect(() => {
    if (blockConfigY !== undefined) {
      if (blockConfigY < 0 && positionClass !== 'at-the-bottom') {
        setPositionClass('at-the-bottom');
      } else if (blockConfigY >= 0 && positionClass !== 'at-the-top') {
        setPositionClass('at-the-top');
      }
    }
  }, [blockConfigY, positionClass]);

  if (!blockContent && blockType !== GridBlockType.SIGNATURE) {
    return <></>;
  }

  const className = 'block-settings-container ' + positionClass;
  const isSignatureBlock = blockType === GridBlockType.SIGNATURE;

  return (
    <Box
      data-testid={`block-settings-container-${blockId}`}
      className={className}
      sx={{ backgroundColor: 'primary.main', display: 'flex', alignItems: 'center' }}
    >
      {isSignatureBlock && <ReassignSigneeTool blockId={blockId} />}
      <LockTool blockId={blockId} isEditMode={isEditMode} setIsEditMode={setIsEditMode} blockType={blockType} />
      {blockType === GridBlockType.TEXT && <AssetInsertTool blockId={blockId} />}
      {blockType === GridBlockType.TEXT && <AssetSaveTool blockId={blockId} />}
      <DeleteTool blockId={blockId} />
    </Box>
  );
}
